<div class="row">
	<div class="col-12 text-center py-2" *ngIf="loading && !catandlines">
		<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>
	</div>
	<div class="col-md-6" *ngIf="catandlines">
		<div class="card card-chart">
			<div class="card-header card-header-icon card-header-danger">
				<div class="card-icon">
					<i class="material-icons">pie_chart</i>
				</div>
				<h4 class="card-title">Product Line Sales Top 10</h4>
			</div>
			<div class="card-body">
				<div class="chart-container bg-white">
					<canvas id="counterPosPlineChart"></canvas>
				</div>
				<div class="boxed" *ngIf="catandlines?.line_sales">
					<table class="table table-fixed">
						<tr *ngFor="let t of catandlines.line_sales">
							<td>
								<span class="labeldata {{t.className}}">&nbsp;&nbsp;</span>&nbsp;
								<span *ngIf="t.label != ''">{{ t.label }}</span>
								<span *ngIf="t.label == ''">**UNKNOWN**</span>
							</td>
							<td class="text-right">{{ t.value | currency }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="col-md-6" *ngIf="catandlines">
		<div class="card card-chart">
			<div class="card-header card-header-icon card-header-danger">
				<div class="card-icon">
					<i class="material-icons">pie_chart</i>
				</div>
				<h4 class="card-title">Product Line Sales Lowest 10</h4>
			</div>
			<div class="card-body">
				<div class="chart-container bg-white">
					<canvas id="counterPosPlineChartR"></canvas>
				</div>
				<div class="boxed" *ngIf="catandlines?.line_sales_reversed">
					<table class="table table-fixed">
						<tr *ngFor="let t of catandlines.line_sales_reversed">
							<td>
								<span class="labeldata {{t.className}}">&nbsp;&nbsp;</span>&nbsp;
								<span *ngIf="t.label != ''">{{ t.label }}</span>
								<span *ngIf="t.label == ''">**UNKNOWN**</span>
							</td>
							<td class="text-right">{{ t.value | currency }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="col-md-6" *ngIf="catandlines">
		<div class="card card-chart">
			<div class="card-header card-header-icon card-header-danger">
				<div class="card-icon">
					<i class="material-icons">pie_chart</i>
				</div>
				<h4 class="card-title">Category Sales</h4>
			</div>
			<div class="card-body">
				<div class="chart-container bg-white">
					<canvas id="counterPosCatChartRef"></canvas>
				</div>
				<div class="boxed" *ngIf="catandlines?.category_sales">
					<table class="table table-fixed">
						<tr *ngFor="let t of catandlines.category_sales">
							<td>
								<span class="labeldata {{t?.className}}">&nbsp;&nbsp;</span>&nbsp;
								<span *ngIf="t.label != ''">{{ t.label }}</span>
								<span *ngIf="t.label == ''">**UNKNOWN**</span>
							</td>
							<td class="text-right">{{ t.value | currency }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
	</div>
</div>
